module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_moducom_m2.dda61985667e81d60bc1bf6b7d610348.png";